import React from 'react';

export default function SprintKpiCards({ kpis }) {
    const fmt = (n) => String(n ?? 0).padStart(2, '0');

    return (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 font-headline">
            {/* Backlog */}
            <div className="bg-white dark:bg-[#1e293b] p-5 rounded-2xl border border-[#e7e8e9] dark:border-slate-700 shadow-sm transition-all hover:shadow-md">
                <p className="text-xs font-bold text-[#737782] dark:text-slate-400 uppercase tracking-widest mb-1">Backlog</p>
                <p className="text-2xl font-black text-[#003263] dark:text-[#a7c8ff] font-headline">
                    {fmt(kpis?.backlog)} <span className="text-xs font-medium text-[#737782] dark:text-slate-400">tasks</span>
                </p>
            </div>

            {/* Current Sprint */}
            <div className="bg-white dark:bg-[#1e293b] p-5 rounded-2xl border-l-4 border-blue-600 shadow-[0px_8px_24px_rgba(3,72,138,0.08)] transition-all hover:shadow-lg">
                <p className="text-xs font-bold text-blue-600 uppercase tracking-widest mb-1">Current Sprint</p>
                <div className="flex flex-col">
                    <p className="text-xl font-black text-[#003263] dark:text-[#a7c8ff] font-headline leading-tight">
                        {fmt(kpis?.inProgress)} Active
                    </p>
                    <p className="text-xs font-bold text-[#737782] dark:text-slate-400">
                        {fmt(kpis?.completed)} Completed
                    </p>
                </div>
            </div>

            {/* Sprint Review */}
            <div className="bg-white dark:bg-[#1e293b] p-5 rounded-2xl border border-[#e7e8e9] dark:border-slate-700 shadow-sm transition-all hover:shadow-md">
                <p className="text-xs font-bold text-[#737782] dark:text-slate-400 uppercase tracking-widest mb-1">Sprint Review</p>
                <p className="text-2xl font-black text-[#003263] dark:text-[#a7c8ff] font-headline">
                    {fmt(kpis?.review)} <span className="text-xs font-medium text-[#737782] dark:text-slate-400">pending</span>
                </p>
            </div>

            {/* Completed */}
            <div className="bg-white dark:bg-[#1e293b] p-5 rounded-2xl border border-[#e7e8e9] dark:border-slate-700 shadow-sm transition-all hover:shadow-md">
                <p className="text-xs font-bold text-[#737782] dark:text-slate-400 uppercase tracking-widest mb-1">Completed</p>
                <p className="text-2xl font-black text-[#003263] dark:text-[#a7c8ff] font-headline">
                    {fmt(kpis?.completed)} <span className="text-xs font-medium text-[#737782] dark:text-slate-400">reviewed</span>
                </p>
            </div>

            {/* Next Sprint */}
            <div className="bg-white dark:bg-[#1e293b] p-5 rounded-2xl border border-[#e7e8e9] dark:border-slate-700 shadow-sm transition-all hover:shadow-md">
                <p className="text-xs font-bold text-[#737782] dark:text-slate-400 uppercase tracking-widest mb-1">Next Sprint</p>
                <p className="text-2xl font-black text-[#003263] dark:text-[#a7c8ff] font-headline">
                    {fmt(kpis?.next)} <span className="text-xs font-medium text-[#737782] dark:text-slate-400">planned</span>
                </p>
            </div>
        </div>
    );
}
